module.exports = __webpack_public_path__ + "img/tu02.937b8b0f.png";